import { filterTitle } from './filter-texts'

export default function (columnName, i18nKey, customFilterTitle = null) {
  if (columnName?.localised && columnName[I18n.locale]) {
    return columnName[I18n.locale]
  }

  if (columnName?.default) {
    return columnName.default
  }

  if (customFilterTitle) {
    return customFilterTitle
  }

  return filterTitle(i18nKey)
}
